import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { http } from 'helpers/axios';
import { format, addWeeks, parse, isValid, isAfter, isEqual } from 'date-fns';
import { store } from 'store/createStore';
import { open } from 'store/modules/modal';
import New from '../components/New';

const DATE_FORMAT = 'MM/DD/YYYY';

const initialValues = {
  start: format(new Date(), DATE_FORMAT),
  stop: format(addWeeks(new Date(), 1), DATE_FORMAT),
  active: true,
  mediaType: ['tv'],
};

const validate = values => {
  const errors = {};
  const requiredFields = [
    'name',
    'brand',
    'active',
    'start',
    'stop',
    'mediaType',
  ];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  // validate dates
  const start = parse(values.start, DATE_FORMAT, initialValues.start);
  if (!isValid(start)) {
    errors.start = 'Invalid date';
  }
  const stop = parse(values.stop, DATE_FORMAT, initialValues.stop);
  if (!isValid(stop)) {
    errors.stop = 'Invalid date';
  }
  if (!isEqual(start, stop) && !isAfter(stop, start)) {
    errors.stop = 'Stop date must be equal or bigger than start date';
  }
  if (!values.mediaType.length) {
    errors.mediaType = 'Required';
  }

  return errors;
};

const $reduxForm = reduxForm({
  form: 'createCampaignForm',
  validate,
  initialValues,

  onSubmit(campaign) {
    const { currentGroup } = store.getState().auth;
    if (typeof currentGroup === 'undefined') {
      throw new SubmissionError({
        _error: `You must to belong to a group to create campaign.`,
      });
    }

    const params = {
      name: campaign.name,
      brand: campaign.brand,
      active: campaign.active,
      mediaType: campaign.mediaType,
      geography: campaign.geography,
      description: campaign.description,
      start: format(campaign.start, DATE_FORMAT),
      stop: format(campaign.stop, DATE_FORMAT),
      value: Number((campaign.value || '0').replace(/[^0-9.-]+/g, '')),
      group: currentGroup._id,
    };

    return http.post('/campaigns', params);
  },

  onSubmitSuccess(result, dispatch, props) {
    props.history.push('/dashboard/cms');
  },

  onSubmitFail(formErrors, dispatch, submitError) {
    if (formErrors) {
      dispatch(
        open({
          modalType: 'error',
          modalProps: {
            message: `Campaign could not be created. Detail: ${
              formErrors._error
            }`,
          },
        })
      );
    } else if (submitError) {
      dispatch(
        open({
          modalType: 'error',
          modalProps: {
            message: `Campaign could not be created. Detail: ${
              submitError.message
            }`,
          },
        })
      );
    }
  },
});

const mapStateToProps = state => {
  return {
    auth: state.auth,
    create: state.create,
  };
};

const mapDispatchToProps = dispatch => ({});

export default $reduxForm(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(New)
);
